import producer from 'immer';
import { Reducer } from 'redux';
import { CommonState, CommonTypes } from './types';

const INITIAL_STATE: CommonState = {
  categorias: null,
  company: null,
  companyAll: null,
  loading: false,
  error: false,
};

const reducer: Reducer<CommonState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CommonTypes.CATEGORIA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CommonTypes.CATEGORIA_SUCCESS:
      return producer(state, draft => {
        draft.categorias = action.payload.data;
        draft.loading = false;
      });
    case CommonTypes.CATEGORIA_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case CommonTypes.COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CommonTypes.COMPANY_SUCCESS:
      return {
        ...state,
        company: action.payload.data,
        loading: false,
      };
    case CommonTypes.COMPANY_FAILURE:
      return {
        ...state,
        signed: false,
        loading: false,
        error: true,
      };
    case CommonTypes.COMPANY_ALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CommonTypes.COMPANY_ALL_SUCCESS:
      return {
        ...state,
        companyAll: action.payload.data,
        loading: false,
      };
    case CommonTypes.COMPANY_ALL_FAILURE:
      return {
        ...state,
        signed: false,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default reducer;
